
import {
  Mixins, Component, Watch, Prop,
} from 'vue-property-decorator';
import { Pagination, Select, Option } from 'element-ui';
import { IBTNCONF } from '@/types/base.d';
import bModal from './bModal.vue';
import tableMixin from './tableMixin';
import { tSearch } from '@/components/Search/index';

@Component({
  components: {
    Pagination,
    bModal,
    tSearch,
    Select,
    Option,
  },
})
export default class tData extends Mixins(tableMixin) {
  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/set/course:add',
    icon: 'plus',
    callback: this.handleAddCourseHour,
    log: {
      name: '机构管理 - 新增',
      component: 'org/mange/components/bModal',
    },
  }];

  private visible: boolean = false;

  private modalTitle: string = '';

  private searchValue = '';

  handleAddCourseHour() {
    this.visible = true;
    this.modalTitle = '添加课程配置';
  }

  handleUpdateForm(row) {
    this.modalTitle = '编辑课程配置';
    this.form = row;
    this.visible = true;
  }

  handleSearchChange(title) {
    this.getData(title);
  }
}
